"use client";
import FormControlLabel, {
  formControlLabelClasses,
} from "@mui/material/FormControlLabel";
import { styled } from "@mui/material/styles";
import { type FormControlLabelProps, LabelOffsetTypes } from "./index";

const styledFormControlLabelOptions = {
  shouldForwardProp: (prop: string) => !["labelOffset"].includes(prop),
};

export const StyledFormControlLabel = styled(
  FormControlLabel,
  styledFormControlLabelOptions,
)<FormControlLabelProps>(({ labelOffset }) => {
  return {
    display: "flex",

    [`& .${formControlLabelClasses.label}`]: {
      width: "100%",
      ...(labelOffset === LabelOffsetTypes.small && {
        marginLeft: "8px",
      }),
      ...(labelOffset === LabelOffsetTypes.medium && {
        marginLeft: "16px",
      }),
    },
  };
});
